import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { usePageContent } from '../hooks/usePageContent';

const AdhvaVibesPSIPage = () => {
  const [activeTab, setActiveTab] = useState('apex');
  const [settings, setSettings] = useState(null);
  const { getContent } = usePageContent('psi', 'hero');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };


  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
    script.async = true;
    script.onload = () => {
      if (window.Chart && document.getElementById('weightageChart')) {
        const ctx = document.getElementById('weightageChart').getContext('2d');
        new window.Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Science & Tech', 'Current Affairs', 'History', 'Geography', 'Mental Ability', 'Indian Polity', 'Economy', 'Static GK/Culture', 'Environment'],
            datasets: [{
              label: 'KPSI Paper-II Weightage',
              data: [15.6, 13.0, 12.9, 11.8, 9.2, 8.6, 8.1, 6.5, 2.2],
              backgroundColor: ['#16a085', '#2980b9', '#8e44ad', '#2c3e50', '#f39c12', '#d35400', '#c0392b', '#7f8c8d', '#34495e'],
              borderColor: '#f8f7f4',
              borderWidth: 3,
              hoverOffset: 10
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'bottom',
                labels: { color: '#2c3e50', font: { size: 12, family: "'Inter', sans-serif" }}
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    let label = context.label || '';
                    if (label) label += ': ';
                    if (context.parsed !== null) label += context.parsed.toFixed(1) + '%';
                    return label;
                  }
                }
              }
            },
            cutout: '60%',
          }
        });
      }
    };
    document.body.appendChild(script);
    return () => { if (document.body.contains(script)) document.body.removeChild(script); };
  }, []);

  const programs = {
    apex: { title: 'Adhva Vibes: The PSI Apex Program', subtitle: 'For the dedicated aspirant aiming for the top.', features: ['Total 37 Comprehensive Tests: 25 for Paper 2 & 12 for Paper 1.', 'Expert Guidance: Personalized feedback and strategic advice for both papers.', 'Valuable Bonus: Free dedicated month-wise Current Affairs test series.'], whoShouldJoin: 'You are highly motivated and aiming for a top rank. You seek expert guidance to help you shine your brightest on exam day.' },
    core: { title: 'Adhva Vibes: The PSI Core Practice Set', subtitle: 'For the disciplined achiever building their own success story.', features: ['Total 37 High-Quality Tests: 25 for Paper 2 & 12 for Paper 1.', 'The Library of Knowledge: Detailed answer keys and explanations.', 'Valuable Bonus: Free dedicated month-wise Current Affairs test series.'], whoShouldJoin: 'You are a disciplined self-starter looking for world-class practice materials to sharpen your skills and perfect your preparation.' },
    descriptive: { title: 'Adhva Vibes: The PSI Descriptive Pro', subtitle: 'Master the art of expression and let your knowledge shine.', features: ['12 Focused Assignments: Master Essay, Précis Writing, and Translation.', 'Relevant Questions: Thoughtfully curated from the latest exam trends.', 'Choose Your Support: Available with or without expert feedback.'], whoShouldJoin: 'You want to develop your writing skills to gain a winning edge after preparing for Paper 2.' },
    mastery: { title: 'Adhva Vibes: Subject Mastery Modules', subtitle: 'Turn every challenge into a new strength.', features: ['History Focus (4 Tests)', 'Geography Explorer (4 Tests)', 'Polity Power-Up (3 Tests)', 'Economy Essentials (3 Tests)', 'Science & Tech Innovator (4 Tests)', 'Environment Awareness (1 Full Test)'], whoShouldJoin: 'You have identified specific areas for improvement and want to master them with renewed confidence.' },
    simulator: { title: 'Adhva Vibes: The Ultimate Exam Simulator', subtitle: 'Experience the real exam before it happens. Walk in with confidence.', features: ['12 Full-Scale Mock Exams: 6 for Paper 2 and 6 for Paper 1.', 'Authentic Exam Experience: Familiarize yourself with the format and conquer the clock.', 'Emerge Confident: Includes detailed performance analysis and All-Karnataka rank.'], whoShouldJoin: 'You are in the final stage of preparation, ready to fine-tune your strategy and build unshakeable confidence.' }
  };

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#f8f7f4', color: '#2c3e50' }}>
      <Navbar />
      
      {/* Show Coming Soon if adhva_vibes_psi_hidden is true */}
      {settings?.adhva_vibes_psi_hidden ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          textAlign: 'center',
          padding: '2rem'
        }}>
          <div style={{
            maxWidth: '600px',
            padding: '3rem',
            background: 'white',
            borderRadius: '1rem',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</div>
            <h2 style={{ marginBottom: '1rem' }}>Coming Soon</h2>
            <p style={{ color: '#6B7280', marginBottom: '2rem', fontSize: '1.125rem' }}>
              We're working on something exciting! The Adhva Vibes PSI page will be available soon.
            </p>
            <a 
              href="/" 
              style={{
                display: 'inline-block',
                padding: '0.75rem 2rem',
                backgroundColor: '#c59d5f',
                color: 'white',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                fontWeight: 600,
                transition: 'all 0.3s'
              }}
            >
              Back to Home
            </a>
          </div>
        </div>
      ) : (
        <>
      <section className="hero-section-mobile" style={{ 
        background: 'linear-gradient(135deg, #f8f7f4 0%, #e8e5df 100%)', 
        minHeight: '70vh', 
        display: 'flex', 
        alignItems: 'center',
        padding: '2rem 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container container-mobile" style={{ 
          margin: '0 auto', 
          padding: '0 1.5rem',
          maxWidth: '1200px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '3rem',
          alignItems: 'center'
        }}>
          <div className="hero-content-mobile" style={{ textAlign: 'left' }}>
            <h1 className="hero-title-mobile" style={{ 
              fontSize: 'clamp(2rem, 5vw, 3.5rem)', 
              fontWeight: 800, 
              color: '#2c3e50', 
              lineHeight: 1.2, 
              marginBottom: '1rem' 
            }}>
              Achieve Your Dream. Earn the Uniform.
            </h1>
            <p className="hero-subtitle-mobile" style={{ 
              fontSize: 'clamp(1rem, 2vw, 1.25rem)', 
              color: '#374151', 
              marginBottom: '2rem',
              lineHeight: 1.7
            }}>
              This isn't just a test series. This is your dedicated roadmap to success in the Karnataka PSI Exam.
            </p>
            <div className="psi-hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <a href="#programs" className="btn-mobile" style={{ 
                backgroundColor: '#c59d5f', 
                color: 'white', 
                padding: '0.75rem 2rem', 
                borderRadius: '0.5rem', 
                fontWeight: 600, 
                fontSize: '1.125rem', 
                textDecoration: 'none', 
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                transition: 'all 0.3s',
                display: 'inline-block'
              }}>
                Explore Our Programs
              </a>
              <a href="#contact" className="btn-mobile" style={{ 
                backgroundColor: 'white', 
                color: '#c59d5f', 
                border: '2px solid #c59d5f', 
                padding: '0.75rem 2rem', 
                borderRadius: '0.5rem', 
                fontWeight: 600, 
                fontSize: '1.125rem', 
                textDecoration: 'none', 
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                transition: 'all 0.3s',
                display: 'inline-block'
              }}>
                Get a Free Sample
              </a>
            </div>
          </div>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center' 
          }}>
            <img 
              src={getContent('officer_image') || "/psi-officer.jpg"}
              alt="PSI Officer - Your Future Awaits" 
              style={{ 
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                borderRadius: '16px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                objectFit: 'cover'
              }}
            />
          </div>
        </div>
      </section>
      <section id="method" style={{ padding: '5rem 0', backgroundColor: 'white' }}>
        <div className="container" style={{ margin: '0 auto', padding: '0 1.5rem', maxWidth: '1200px' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: 'clamp(1.875rem, 4vw, 2.25rem)', fontWeight: 700, color: '#2c3e50', marginBottom: '1rem' }}>The Adhva Vibes Advantage</h2>
            <p style={{ fontSize: '1.125rem', color: '#6b7280', maxWidth: '48rem', margin: '0 auto' }}>We replace doubt and guesswork with clarity and focus. Our programs are a systematic journey to excellence, guiding you from foundational concepts to peak performance with encouragement at every step.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
            <div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#2c3e50', marginBottom: '1rem' }}>The Blueprint for Success: A Data-Driven Strategy</h3>
              <p style={{ color: '#6b7280', marginBottom: '1rem' }}>Success is not an accident. Our strategy is built on the unshakeable foundation of data—a rigorous analysis of what the PSI exam truly demands. This chart represents the average subject weightage in Paper-II, based on our analysis of previous exams.</p>
              <p style={{ color: '#6b7280' }}>This data-driven blueprint is your map to success, ensuring your energy and focus are invested where they will yield the greatest results. Hover over the chart to explore the breakdown.</p>
            </div>
            <div style={{ position: 'relative', margin: 'auto', height: '40vh', maxHeight: '400px', width: '100%', maxWidth: '400px' }}><canvas id="weightageChart"></canvas></div>
          </div>
        </div>
      </section>
      <section id="programs" style={{ padding: '5rem 0' }}>
        <div className="container" style={{ margin: '0 auto', padding: '0 1.5rem', maxWidth: '1200px' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: 'clamp(1.875rem, 4vw, 2.25rem)', fontWeight: 700, color: '#2c3e50', marginBottom: '1rem' }}>Find Your Perfect Path</h2>
            <p style={{ fontSize: '1.125rem', color: '#6b7280', maxWidth: '48rem', margin: '0 auto' }}>Your journey is unique. We have crafted a suite of positive and powerful programs designed to amplify your strengths and help you achieve your goals. Select a program below to learn more.</p>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.5rem 1rem', marginBottom: '2rem' }}>
            {Object.keys(programs).map((key) => (
              <button key={key} onClick={() => setActiveTab(key)} style={{ padding: '0.75rem 1.5rem', fontSize: '1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer', transition: 'all 0.3s', backgroundColor: activeTab === key ? '#c59d5f' : '#e5e7eb', color: activeTab === key ? 'white' : '#374151', fontWeight: activeTab === key ? 600 : 500 }}>
                {key === 'apex' && 'PSI Apex Program'}{key === 'core' && 'Core Practice Set'}{key === 'descriptive' && 'Descriptive Pro'}{key === 'mastery' && 'Subject Mastery'}{key === 'simulator' && 'Exam Simulator'}
              </button>
            ))}
          </div>
          <div style={{ position: 'relative', minHeight: '450px' }}>
            {Object.entries(programs).map(([key, program]) => (
              <div key={key} style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.75rem', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', border: '1px solid #e5e7eb', opacity: activeTab === key ? 1 : 0, transform: activeTab === key ? 'scale(1)' : 'scale(0.95)', position: activeTab === key ? 'relative' : 'absolute', pointerEvents: activeTab === key ? 'auto' : 'none', transition: 'opacity 0.5s, transform 0.5s', width: '100%' }}>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#c59d5f', marginBottom: '0.5rem' }}>{program.title}</h3>
                <p style={{ fontStyle: 'italic', color: '#6b7280', marginBottom: '1rem' }}>{program.subtitle}</p>
                <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', lineHeight: 2 }}>
                  {program.features.map((feature, idx) => (
                    <li key={idx} style={{ color: '#374151' }}>{feature.includes(':') ? <><strong>{feature.split(':')[0]}:</strong>{feature.split(':')[1]}</> : feature}</li>
                  ))}
                </ul>
                <p style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Who Should Join?</p>
                <p style={{ color: '#6b7280' }}>{program.whoShouldJoin}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="why-us" style={{ padding: '5rem 0', backgroundColor: 'white' }}>
        <div className="container" style={{ margin: '0 auto', padding: '0 1.5rem', maxWidth: '1200px' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: 'clamp(1.875rem, 4vw, 2.25rem)', fontWeight: 700, color: '#2c3e50', marginBottom: '1rem' }}>Your Keys to Success</h2>
            <p style={{ fontSize: '1.125rem', color: '#6b7280', maxWidth: '48rem', margin: '0 auto' }}>Our method is designed to provide you with a clear, confident, and complete path to achieving your dream.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            {[{ title: 'Success by Design', desc: 'Our plan is a scientifically designed journey, focusing your energy on high-yield topics for maximum results.' }, { title: 'Master the Core Pillars', desc: 'Every sectional test includes 20 Mental Ability questions to consistently sharpen your analytical skills.' }, { title: 'Current Affairs Mastery', desc: 'Receive a dedicated month-wise Current Affairs test series FREE with our core programs.' }, { title: 'The Journey to Mastery', desc: 'Progress from individual sections to entire subjects, building strong and positive momentum for the final exams.' }, { title: 'Think Like a Topper', desc: 'Our integrated approach helps you link foundational knowledge with current events, making you a truly insightful candidate.' }, { title: 'Paper 1 Mentorship', desc: 'Go beyond corrections with detailed feedback and personalized guidance to develop the communication skills of a leader.' }].map((item, idx) => (
              <div key={idx} style={{ backgroundColor: '#f9fafb', padding: '1.5rem', borderRadius: '0.5rem' }}>
                <h3 style={{ fontWeight: 700, fontSize: '1.25rem', marginBottom: '0.5rem', color: '#2c3e50' }}>{item.title}</h3>
                <p style={{ color: '#6b7280' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="contact" style={{ padding: '5rem 0', backgroundColor: '#1f2937', color: 'white' }}>
        <div className="container" style={{ margin: '0 auto', padding: '0 1.5rem', textAlign: 'center', maxWidth: '1200px' }}>
          <h2 style={{ fontSize: 'clamp(1.875rem, 4vw, 2.25rem)', fontWeight: 700, marginBottom: '1rem' }}>Your Future Awaits. Begin Your Journey Today.</h2>
          <p style={{ fontSize: '1.125rem', color: '#d1d5db', maxWidth: '48rem', margin: '0 auto 2rem' }}>The journey of a thousand miles begins with a single, positive step. The uniform is waiting. Your future is waiting. Take that step now.</p>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
            <a href="https://forms.gle/5mjmuxov7LaYCHTU6" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#c59d5f', color: 'white', padding: '0.75rem 2rem', borderRadius: '0.5rem', fontWeight: 600, fontSize: '1.125rem', textDecoration: 'none', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s', display: 'inline-block' }}>Start My Journey! (Enroll Now)</a>
            <a href="https://forms.gle/5mjmuxov7LaYCHTU6" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: 'white', color: '#1f2937', padding: '0.75rem 2rem', borderRadius: '0.5rem', fontWeight: 600, fontSize: '1.125rem', textDecoration: 'none', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s', display: 'inline-block' }}>Explore a Sample Test</a>
          </div>
        </div>
      </section>
      </>
      )}
      <Footer />
    </div>
  );
};

export default AdhvaVibesPSIPage;
